import autosize from 'autosize';

import Cart from './components/cart';
import ContactForm from './components/contactForm';
import EqualHeight from './components/equalHeight';
import GiftSubscriptionForm from './components/giftSubscriptionForm';
import Producer from './components/producer';
import SharePopup from './components/sharePopup';
import Slider from './components/slider';
import SubscriptionBuilder from './components/subscriptionBuilder.svelte';

/* eslint-disable no-unused-vars */
const contactForm = new ContactForm();
const producer = new Producer();
const giftSubscriptionForm = new GiftSubscriptionForm();
const cart = new Cart();
/* eslint-enable no-unused-vars */

const slider = Slider.init();
EqualHeight.init();

const subscriptionBuilderContainer = document.querySelector('.js-subscription_builder');
if (subscriptionBuilderContainer) {
  // eslint-disable-next-line no-unused-vars
  const subscriptionBuilder = new SubscriptionBuilder({
    target: subscriptionBuilderContainer,
    props: {
      debug: subscriptionBuilderContainer.dataset.debug,
      recurring: subscriptionBuilderContainer.dataset.recurring,
    },
  });
}

// On Load
autosize(document.querySelectorAll('textarea'));

// Pick 3 random items from the grid
const gridItems = document.querySelectorAll('.js-pick .grid-item');
const itemsArray = Array.from(gridItems);
const numToKeep = 3;

// Shuffle array
for (let i = itemsArray.length - 1; i > 0; i--) {
  const j = Math.floor(Math.random() * (i + 1));
  [itemsArray[i], itemsArray[j]] = [itemsArray[j], itemsArray[i]];
}

// Remove all but first numToKeep items
itemsArray.slice(numToKeep).forEach(item => item.remove());

document.querySelectorAll('.js-share-popup').forEach(button => {
  button.addEventListener('click', (event) => {
    event.preventDefault();
    SharePopup.open(button.getAttribute('href'));
  });
});

window.setTimeout(() => {
  document.querySelector('html.wf-loading')?.classList.remove('wf-loading');
}, 3000);

document.querySelectorAll('.js-nav_toggle').forEach(toggle => {
  toggle.addEventListener('click', (event) => {
    event.preventDefault();
    document.body.classList.toggle('nav-active');
    toggle.textContent = toggle.textContent === 'Menu' ? 'Close' : 'Menu';
  });
});

document.querySelectorAll('.js-subheader').forEach(toggle => {
  const subheaderNavList = toggle.querySelector('.subheader-nav-list');

  const checkOverflow = () => {
    if (subheaderNavList.scrollWidth > subheaderNavList.clientWidth) {
      subheaderNavList.classList.add('is-overflowing');
    } else {
      subheaderNavList.classList.remove('is-overflowing');
    }
  };

  // Check on load
  checkOverflow();

  // Check on resize
  window.addEventListener('resize', checkOverflow);
});

document.querySelectorAll('.js-announcement-toggle').forEach(toggle => {
  toggle.addEventListener('click', (event) => {
    event.preventDefault();
    const announcement = document.querySelector('.js-announcement');
    const expandedElement = announcement.querySelector('.announcement-expanded');
    const isExpanded = announcement?.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    if (announcement) {
      announcement.setAttribute('id', 'announcement');
      expandedElement?.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');
    }
  });
});

document.querySelectorAll('.js-content_toggle button').forEach(link => {
  link.addEventListener('click', (event) => {
    const activeClass = 'is-active';
    const parent = link.parentElement;
    const siblings = parent.querySelectorAll('button');
    siblings.forEach(sibling => sibling.classList.remove(activeClass));
    link.classList.add(activeClass);
    siblings.forEach(sibling => sibling.setAttribute('aria-selected', 'false'));
    const contentItems = Array.from(parent.parentElement.children).filter(el => !el.matches('.js-content_toggle'));
    contentItems.forEach(item => item.classList.remove(activeClass));
    contentItems[Array.from(siblings).indexOf(link)].classList.add(activeClass);

    // Set the aria-selected attribute on the button
    link.setAttribute('aria-selected', 'true');
  });
});

document.querySelectorAll('.image_w_text_card').forEach(card => {
  card.classList.remove('is-hidden');
});

document.querySelectorAll('.js-to_top').forEach(button => {
  button.addEventListener('click', (event) => {
    event.preventDefault();

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    const focusableElements = document.body.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

    // Focus the second focusable element (skip the skip to content link)
    focusableElements[1].focus();
  });
});

document.querySelectorAll('.js-animate_scroll').forEach(link => {
  link.addEventListener('click', (event) => {
    event.preventDefault();
    const target = document.querySelector(link.getAttribute('href'));
    const padding = link.dataset.scrollPadding || 0;
    if (target) {
      const top = target.getBoundingClientRect().top + window.pageYOffset - padding;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  });
});

document.querySelectorAll('.js-component_view-toggle').forEach(toggle => {
  toggle.addEventListener('click', (event) => {
    event.preventDefault();
    document.querySelectorAll('.js-component_view').forEach(view => view.classList.toggle('is-hidden'));
    toggle.closest('.js-component_view')?.classList.toggle('is-active');
    const id = toggle.closest('.component_library-heading')?.id;
    setTimeout(() => {
      window.location.hash = id;
    }, 50);
  });
});

document.querySelectorAll('.js-show_all_siblings').forEach(button => {
  button.addEventListener('click', (event) => {
    event.preventDefault();
    button.style.display = 'none';
    Array.from(button.parentElement.children)
      .filter(sibling => sibling !== button)
      .forEach(sibling => sibling.classList.remove('is-hidden'));
  });
});
